// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabelas-peso-container {
  padding: 24px;
  background-color: var(--bg-base);
  min-height: 100vh;
}

.tabelas-peso-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.tabelas-peso-header h1 {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.tabelas-peso-header p {
  color: var(--text-secondary);
  margin: 4px 0 0 0;
  font-size: 14px;
}

/* Grid Layout */
.tabela-grid-container {
  background: var(--bg-surface);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--border-light);
  overflow-x: auto;
  margin-bottom: 24px;
}

.tabela-peso-grid {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.tabela-peso-grid th,
.tabela-peso-grid td {
  border: 1px solid var(--border-light);
  padding: 6px 4px;
  text-align: center;
  font-size: 11px;
}

/* Header Cells (Idades) */
.tabela-peso-grid th.col-idade {
  background-color: #A9D0F5; /* Azul claro padrão de categorias */
  color: #111;
  font-weight: 700;
  line-height: 1.2;
}

.tabela-peso-grid th.col-idade.adulto {
  background-color: #FFB6C1; /* Rosa para adulto master FEM */
}
.tabela-peso-grid th.col-idade.adulto-masc {
  background-color: #A9D0F5; /* Azul para adulto master MAS */
}

/* Row Headers (Categorias) */
.tabela-peso-grid th.row-categoria {
  background-color: #FFE4B5; /* Laranja clarinho */
  color: #111;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
  white-space: nowrap;
  width: 90px;
  font-size: 10px;
}

.tabela-peso-grid th.row-categoria.medio {
  background-color: #FF0000;
  color: white;
}

.tabela-peso-grid th.row-categoria.absoluto {
  background-color: #FFFF00;
}

/* Data Cells */
.tabela-peso-grid td {
  background-color: #90EE90; /* Verde padrão */
  font-weight: 500;
  color: #111;
}

.tabela-peso-grid td.nao-tem {
  background-color: #90EE90;
  font-weight: 700;
}

.tabela-peso-grid td.peso-livre {
  background-color: #90EE90;
  font-weight: 700;
}

.tabela-peso-grid td.empty {
  background-color: #F8FAFC; /* Quase branco/cinza muito claro para dar contraste */
}

/* Inputs within grid */
.grid-input {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  text-align: center;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  outline: none;
  resize: none;
}

.grid-input::placeholder {
  color: #94A3B8; /* Cinza médio, visível */
  opacity: 1; /* Firefox abaixa a opacidade por padrão */
  font-weight: 600;
}

.grid-input:focus {
  background-color: rgba(255,255,255,0.8);
  box-shadow: inset 0 0 0 2px var(--brand-navy, #111827);
}

/* Toolbar */
.tabela-toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  background: var(--bg-surface);
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.tabela-toolbar button,
.import-btn-label {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid var(--border-light);
  background: white;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #111;
}
.tabela-toolbar button:hover,
.import-btn-label:hover {
  background: var(--bg-surface-2);
}
.tabela-toolbar button.primary {
  background: var(--brand-navy, #111827);
  color: white;
  border: none;
}
.tabela-toolbar button.primary:hover {
  background: var(--brand-navy-light, #374151);
}

/* Custom Toast Notification */
.toast-notification {
  position: fixed;
  top: 32px;
  right: 32px;
  background-color: #1F2937;
  color: #fff;
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  animation: slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  border-left: 4px solid var(--brand-navy);
}

.toast-notification.success {
  border-left-color: #10B981;
}

.toast-icon {
  font-size: 20px;
}

.toast-message {
  font-size: 14px;
  font-weight: 500;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Custom Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;
}

.modal-content {
  background-color: var(--bg-surface, #fff);
  padding: 24px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-content h3 {
  margin: 0 0 12px 0;
  font-size: 18px;
  color: #111;
}

.modal-content p {
  margin: 0 0 24px 0;
  font-size: 14px;
  color: #4B5563;
}

.modal-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-light, #E5E7EB);
  border-radius: 6px;
  margin-bottom: 24px;
  font-size: 14px;
  outline: none;
  font-family: inherit;
}

.modal-input:focus {
  border-color: var(--brand-navy, #111827);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.modal-actions button {
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.modal-actions button.btn-cancel {
  background-color: #F3F4F6;
  color: #374151;
}
.modal-actions button.btn-cancel:hover {
  background-color: #E5E7EB;
}

.modal-actions button.btn-confirm {
  background-color: var(--brand-navy, #111827);
  color: white;
}
.modal-actions button.btn-confirm:hover {
  background-color: var(--brand-navy-light, #374151);
}
.modal-actions button.btn-confirm.danger {
  background-color: #EF4444;
}
.modal-actions button.btn-confirm.danger:hover {
  background-color: #DC2828;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TabelasPeso.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;AACA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB,EAAE,qBAAqB;EAChD,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,sDAAsD;AACnF;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,yBAAyB;EACzC,UAAU,EAAE,0CAA0C;EACtD,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,sDAAsD;AACxD;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mFAAmF;EACnF,aAAa;EACb,0DAA0D;EAC1D,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,qFAAqF;AACvF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;AACA;EACE,kDAAkD;AACpD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB","sourcesContent":[".tabelas-peso-container {\n  padding: 24px;\n  background-color: var(--bg-base);\n  min-height: 100vh;\n}\n\n.tabelas-peso-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.tabelas-peso-header h1 {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.tabelas-peso-header p {\n  color: var(--text-secondary);\n  margin: 4px 0 0 0;\n  font-size: 14px;\n}\n\n/* Grid Layout */\n.tabela-grid-container {\n  background: var(--bg-surface);\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--border-light);\n  overflow-x: auto;\n  margin-bottom: 24px;\n}\n\n.tabela-peso-grid {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.tabela-peso-grid th,\n.tabela-peso-grid td {\n  border: 1px solid var(--border-light);\n  padding: 6px 4px;\n  text-align: center;\n  font-size: 11px;\n}\n\n/* Header Cells (Idades) */\n.tabela-peso-grid th.col-idade {\n  background-color: #A9D0F5; /* Azul claro padrão de categorias */\n  color: #111;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.tabela-peso-grid th.col-idade.adulto {\n  background-color: #FFB6C1; /* Rosa para adulto master FEM */\n}\n.tabela-peso-grid th.col-idade.adulto-masc {\n  background-color: #A9D0F5; /* Azul para adulto master MAS */\n}\n\n/* Row Headers (Categorias) */\n.tabela-peso-grid th.row-categoria {\n  background-color: #FFE4B5; /* Laranja clarinho */\n  color: #111;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: left;\n  white-space: nowrap;\n  width: 90px;\n  font-size: 10px;\n}\n\n.tabela-peso-grid th.row-categoria.medio {\n  background-color: #FF0000;\n  color: white;\n}\n\n.tabela-peso-grid th.row-categoria.absoluto {\n  background-color: #FFFF00;\n}\n\n/* Data Cells */\n.tabela-peso-grid td {\n  background-color: #90EE90; /* Verde padrão */\n  font-weight: 500;\n  color: #111;\n}\n\n.tabela-peso-grid td.nao-tem {\n  background-color: #90EE90;\n  font-weight: 700;\n}\n\n.tabela-peso-grid td.peso-livre {\n  background-color: #90EE90;\n  font-weight: 700;\n}\n\n.tabela-peso-grid td.empty {\n  background-color: #F8FAFC; /* Quase branco/cinza muito claro para dar contraste */\n}\n\n/* Inputs within grid */\n.grid-input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  color: inherit;\n  outline: none;\n  resize: none;\n}\n\n.grid-input::placeholder {\n  color: #94A3B8; /* Cinza médio, visível */\n  opacity: 1; /* Firefox abaixa a opacidade por padrão */\n  font-weight: 600;\n}\n\n.grid-input:focus {\n  background-color: rgba(255,255,255,0.8);\n  box-shadow: inset 0 0 0 2px var(--brand-navy, #111827);\n}\n\n/* Toolbar */\n.tabela-toolbar {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  background: var(--bg-surface);\n  padding: 16px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.tabela-toolbar button,\n.import-btn-label {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: 1px solid var(--border-light);\n  background: white;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #111;\n}\n.tabela-toolbar button:hover,\n.import-btn-label:hover {\n  background: var(--bg-surface-2);\n}\n.tabela-toolbar button.primary {\n  background: var(--brand-navy, #111827);\n  color: white;\n  border: none;\n}\n.tabela-toolbar button.primary:hover {\n  background: var(--brand-navy-light, #374151);\n}\n\n/* Custom Toast Notification */\n.toast-notification {\n  position: fixed;\n  top: 32px;\n  right: 32px;\n  background-color: #1F2937;\n  color: #fff;\n  padding: 16px 24px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n  animation: slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  border-left: 4px solid var(--brand-navy);\n}\n\n.toast-notification.success {\n  border-left-color: #10B981;\n}\n\n.toast-icon {\n  font-size: 20px;\n}\n\n.toast-message {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Custom Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.modal-content {\n  background-color: var(--bg-surface, #fff);\n  padding: 24px;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.modal-content h3 {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  color: #111;\n}\n\n.modal-content p {\n  margin: 0 0 24px 0;\n  font-size: 14px;\n  color: #4B5563;\n}\n\n.modal-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border-light, #E5E7EB);\n  border-radius: 6px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  outline: none;\n  font-family: inherit;\n}\n\n.modal-input:focus {\n  border-color: var(--brand-navy, #111827);\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.modal-actions button {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n}\n\n.modal-actions button.btn-cancel {\n  background-color: #F3F4F6;\n  color: #374151;\n}\n.modal-actions button.btn-cancel:hover {\n  background-color: #E5E7EB;\n}\n\n.modal-actions button.btn-confirm {\n  background-color: var(--brand-navy, #111827);\n  color: white;\n}\n.modal-actions button.btn-confirm:hover {\n  background-color: var(--brand-navy-light, #374151);\n}\n.modal-actions button.btn-confirm.danger {\n  background-color: #EF4444;\n}\n.modal-actions button.btn-confirm.danger:hover {\n  background-color: #DC2828;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
